export const MAX_NUMBER_OF_ATTEMPTS_TO_SAVE_NOTE = 5;
export const TIME_TO_WAIT_CONTAINER_FLEX_TRANSITION = 300;
